import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Login/login';
import { css } from '@patternfly/react-styles';
export var LoginHeader = function LoginHeader(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$headerBrand = _a.headerBrand,
      headerBrand = _a$headerBrand === void 0 ? null : _a$headerBrand,
      props = __rest(_a, ["className", "children", "headerBrand"]);

  return React.createElement("header", Object.assign({
    className: css(styles.loginHeader, className)
  }, props), headerBrand, children);
};